import { css } from '@emotion/core';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
import * as commonStyles from './common.style';
var bodyLeftPadding = '51px';
var sidebarWidth = '300px';
export var breadcrumbs = /*#__PURE__*/css(commonStyles.breadcrumbs, " margin-left:0;");
export var upLevel = /*#__PURE__*/css(commonStyles.upLevel, " margin:0;padding:0 0 0 ", bodyLeftPadding, ";");
export var title = /*#__PURE__*/css(commonStyles.title, " text-align:left;padding:0 0 0 ", bodyLeftPadding, ";");
export var titleHeading = /*#__PURE__*/css(typography.headingXL, " margin-bottom:5px;");
export var titleSubheading = /*#__PURE__*/css(typography.body);
export var pow1 = /*#__PURE__*/css(commonStyles.pow1, " width:", sidebarWidth, ";margin-bottom:32px;");
export var browseOptions = /*#__PURE__*/css(commonStyles.browseOptions, " width:", sidebarWidth, ";margin:0 0 32px;padding:0;");
export var browseSuburbs = /*#__PURE__*/css(commonStyles.browseSuburbs, " width:670px;padding:0 0 0 ", bodyLeftPadding, ";");
export var advert = /*#__PURE__*/css(commonStyles.advert, " width:", sidebarWidth, ";margin-top:0;");
export var body = {
  name: "epvm6",
  styles: "white-space:nowrap;"
};
export var bodyLeft = {
  name: "1odj455",
  styles: "display:inline-block;vertical-align:top;margin-top:24px;width:300px;"
};
export var bodyRight = {
  name: "csod6h",
  styles: "display:inline-block;vertical-align:top;white-space:normal;"
};
export var upLevelContainer = {
  name: "15p9n5u",
  styles: "height:24px;"
};